
import { Injectable } from '@angular/core';
import { fromEvent, merge, interval, Observable } from 'rxjs';
import { map, repeat, takeUntil } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class IdleService {
  private idleMinutes = 20;
  readonly onIdle$: Observable<void>;
  constructor() {
    const events = ['click','keypress','wheel','mousemove','touchstart'];
    const signal$ = merge(...events.map(e => fromEvent(document, e)));
    this.onIdle$ = interval(this.idleMinutes * 60 * 1000).pipe(
      takeUntil(signal$), map(() => void 0), repeat()
    );
  }
}
